"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "withErrorBoundary", {
  enumerable: true,
  get: function get() {
    return _withErrorBoundary["default"];
  }
});
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
var _withErrorBoundary = _interopRequireDefault(require("./withErrorBoundary"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = _ErrorBoundary["default"];